/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Seo_Product_Description_Tpl1Inputs */

const vi_sitesettings_seo_product_description_tpl1 = /** @type {(inputs: Sitesettings_Seo_Product_Description_Tpl1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mẫu mô tả trang sản phẩm`)
};

/**

* @param {Sitesettings_Seo_Product_Description_Tpl1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_seo_product_description_tpl1 = /** @type {((inputs?: Sitesettings_Seo_Product_Description_Tpl1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Seo_Product_Description_Tpl1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_seo_product_description_tpl1(inputs)
});
export { sitesettings_seo_product_description_tpl1 as "siteSettings_seo_product_description_tpl" }